<div class="modals payment-success" [class.modals-show]="isModalPaymentSuccessShow"
     [class.modals-hide]="!isModalPaymentSuccessShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h2 class="text-center">Успішно відправлено</h2>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
